import type { ReactNode } from 'react';

type PageHeroProps = {
  eyebrow?: string;
  title: string;
  intro?: ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  roomyBottom?: boolean;
};

export default function PageHero({ eyebrow, title, intro, imageSrc, imageAlt, roomyBottom }: PageHeroProps) {
  return (
    <section className="relative w-full overflow-hidden bg-background-50">
      {imageSrc ? (
        <>
          <div className="absolute inset-0">
            <img src={imageSrc} alt={imageAlt || ''} className="w-full h-full object-cover object-top" />
          </div>
          {/* Legibility scrim — darkest behind the left-aligned text, fading across the photo */}
          <div className="absolute inset-0 hero-scrim-left" aria-hidden="true"></div>
          {/* Subtle charcoal fade so the under-hero breathing room matches the dark page */}
          <div className="absolute inset-x-0 bottom-0 h-2/5 hero-fade-bottom" aria-hidden="true"></div>
        </>
      ) : (
        <div className="absolute inset-0 bg-gradient-to-b from-background-100 to-background-50"></div>
      )}
      <div
        className={`relative w-full px-4 md:px-8 lg:px-12 pt-36 md:pt-48 ${
          roomyBottom ? 'pb-28 md:pb-40' : 'pb-16 md:pb-24'
        }`}
      >
        <div className="max-w-content mx-auto">
          <div className="max-w-3xl">
            {eyebrow ? (
              <span className="hero-text-shadow font-label text-xs uppercase tracking-widest2 text-primary-400">
                {eyebrow}
              </span>
            ) : null}
            <h1 className="hero-text-shadow mt-5 font-heading text-3xl md:text-5xl leading-[1.1] text-foreground-950">
              {title}
            </h1>
            {intro ? (
              <div className="hero-text-shadow mt-5 text-base md:text-lg leading-relaxed text-foreground-900 max-w-2xl space-y-3">
                {intro}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </section>
  );
}